<template>
  <a-modal
      :title="'修改' + item.label"
      :width="500"
      :visible="visible"
      :confirmLoading="false"
      @ok="() => { $emit('ok') }"
      @cancel="() => { $emit('cancel') }"
  >
    <a-form :form="form" :label-col="{span:6}" :wrapper-col="{span:15}" autoComplete="off">
      <a-form-item label="ID" v-show="false">
        <a-input type="hidden" v-decorator="['field', {initialValue: item.field}]" />
      </a-form-item>
      <a-form-item :label="item.label">
        <a-input
          v-decorator="['val', {initialValue: item.val, rules: [
            {required: true, message: '必填，不能为空'},
          ]}]"
        />
      </a-form-item>
    </a-form>
  </a-modal>
</template>

<script>
export default {
  props: {
    visible: {
      type: Boolean,
      required: true
    },
    item: {
      type: Object,
      default: () => null
    }
  },
  data() {
    return {
      form: this.$form.createForm(this),
      model: {}
    }
  },
  created() {
    this.model.val = this.val;
  },
  methods: {

  }
}
</script>
